
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"100","width":"100","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 65 65"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M56.2 31.8c0-13-10.6-23.7-23.7-23.7-13 0-23.7 10.6-23.7 23.7 0 13 10.6 23.7 23.7 23.7 13 0 23.7-10.6 23.7-23.7zm-45.9 0c0-12.2 9.9-22.2 22.2-22.2s22.2 9.9 22.2 22.2C54.7 44 44.7 54 32.5 54S10.3 44 10.3 31.8z"}}),_c('path',{attrs:{"d":"M32.5 34.9c1.7 0 3.1-1.4 3.1-3.1 0-1.5-1-2.7-2.4-3v-10h-1.5v10c-1.1.3-2 1.1-2.3 2.3H21v1.5h8.4c.4 1.3 1.6 2.3 3.1 2.3zm0-4.7c.9 0 1.6.7 1.6 1.6 0 .9-.7 1.6-1.6 1.6-.9 0-1.6-.7-1.6-1.6 0-.9.7-1.6 1.6-1.6zM25.237 12.339l1.072 2.587-1.386.574-1.072-2.587zM13.585 23.103l2.587 1.072-.574 1.386-2.587-1.072zM13.614 40.345l-.574-1.386 2.586-1.072.575 1.385zM25.206 51.117l-1.386-.574 1.071-2.587 1.386.574zM39.888 48.087l1.072 2.587-1.386.574-1.071-2.587zM51.272 40.406l-2.586-1.071.574-1.386 2.586 1.071zM51.316 23.171l.574 1.386-2.587 1.072-.574-1.386zM39.682 12.408l1.386.574-1.071 2.587-1.386-.574zM31.8 11.1h1.5v4.7h-1.5zM18.295 16.624l3.324 3.323-1.061 1.061-3.323-3.323zM46.582 16.621l1.06 1.06-3.323 3.324-1.06-1.06zM11.7 31.1h4.7v1.5h-4.7zM18.318 47.005l-1.06-1.061 3.324-3.323 1.06 1.061zM31.7 47.9h1.5v4.7h-1.5zM44.338 42.655l3.324 3.324-1.061 1.06-3.324-3.323zM48.5 31.1h4.7v1.5h-4.7z"}}),_c('path',{attrs:{"d":"M43.6 56.9C53.3 52.7 60 43 60 31.8c0-13.4-9.6-24.6-22.3-27V1.5c0-1-.8-1.8-1.8-1.8h-6.8c-1 0-1.8.8-1.8 1.8v3.3C14.6 7.3 5 18.4 5 31.8 5 43 11.7 52.7 21.4 56.9l-19 3.8v4.5h60.1v-4.5l-18.9-3.8zM28.8 1.5c0-.2.1-.3.3-.3h6.8c.2 0 .3.1.3.3v3.1c-1.2-.2-2.4-.3-3.7-.3-1.3 0-2.5.1-3.7.3V1.5zM6.5 31.8c0-14.3 11.7-26 26-26s26 11.7 26 26-11.7 26-26 26-26-11.6-26-26zm54.6 32H3.9V62l20-4c2.7.9 5.6 1.4 8.5 1.4 3 0 5.8-.5 8.5-1.4l20 4v1.8z"}})])
          )
        }
      }
    